/**
 * Pulzena Collection Filters — couche custom isolée
 * ══════════════════════════════════════════════════
 *
 * ARCHITECTURE (résiste aux MAJ Pulzena) :
 * - Ce fichier injecte du HTML/comportement par-dessus Pulzena
 * - Aucun fichier Pulzena natif modifié (sauf 1 ligne dans theme.liquid)
 * - CSS companion : pulzena-custom.css (section "COLLECTION FILTERS")
 *
 * FONCTIONS :
 * 1. Injecte bloc "COLLECTIONS" (nav par audience) au-dessus des filtres
 * 2. Force open tous les accordéons <details> (Pulzena les ferme par défaut)
 * 3. Masque le filtre "Collections liées" de Pulzena (remplacé par notre nav)
 * 4. MutationObserver pour ré-appliquer après AJAX filter updates
 *
 * MAINTENANCE APRÈS MAJ Pulzena :
 * Vérifier que theme.liquid contient encore :
 *   <script src="{{ 'pulzena-filters.js' | asset_url }}" defer></script>
 */
(function () {

  /* ── Collections nav data ─────────────────────────────
     Counts fetched dynamically from Shopify AJAX API.
     Order = display order in sidebar. */
  var COLLECTIONS = [
    { label: 'Femme',           handle: 'montre-connectee-femme',   icon: '♀', count: null },
    { label: 'Homme',           handle: 'montre-connectee-homme',   icon: '♂', count: null },
    { label: 'Sport & Fitness', handle: 'montre-connectee-sport',   icon: '⚡', count: null },
    { label: 'Enfant & Ado',    handle: 'montre-connectee-enfant',  icon: '👦', count: null },
    { label: 'Coups de Coeur', handle: 'notre-selection',          icon: '★', count: null }
  ];

  /* ── Fetch live product counts per collection ──────── */
  function fetchCollectionCounts() {
    COLLECTIONS.forEach(function (col) {
      fetch('/collections/' + col.handle + '.json')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (data && data.collection && typeof data.collection.products_count === 'number') {
            col.count = data.collection.products_count;
            var countEl = document.querySelector('.pz-collection-count[data-handle="' + col.handle + '"]');
            if (countEl) countEl.textContent = col.count;
          }
        })
        .catch(function () { /* silent — count stays hidden */ });
    });
  }

  /* ── Detect current collection from URL ────────────── */
  function getCurrentHandle() {
    var match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  /* ── Step 1 : Inject COLLECTIONS nav block ─────────── */
  function injectCollectionsNav(sidebar) {
    if (document.getElementById('pz-collections-nav')) return;

    var currentHandle = getCurrentHandle();
    var html = '<div id="pz-collections-nav" class="pz-filter-section">';
    html += '<div class="pz-filter-title">COLLECTIONS</div>';
    html += '<div class="pz-collections-list">';

    COLLECTIONS.forEach(function (col) {
      var isActive = currentHandle === col.handle
                  || currentHandle.indexOf(col.handle + '-') === 0;
      var cls = 'pz-collection-item' + (isActive ? ' pz-collection-active' : '');
      html += '<a href="/collections/' + col.handle + '" class="' + cls + '">';
      html += '<span class="pz-collection-icon">' + col.icon + '</span>';
      html += '<span class="pz-collection-label">' + col.label + '</span>';
      html += '<span class="pz-collection-count" data-handle="' + col.handle + '">' + (col.count !== null ? col.count : '') + '</span>';
      html += '</a>';
    });

    html += '</div></div>';

    // Insert before the first accordion-list in sidebar
    var accList = sidebar.querySelector('.accordion-list');
    if (accList) {
      accList.insertAdjacentHTML('beforebegin', html);
    }
  }

  /* ── Step 2 : Open accordions + hide "Collections liées" ── */
  function enhanceFilters() {
    // Force all accordions open
    document.querySelectorAll('.accordion-list details').forEach(function (d) {
      d.setAttribute('open', '');
    });

    // Hide "Collections liées" filter (replaced by our nav block)
    document.querySelectorAll('.accordion-list .text-with-icon').forEach(function (span) {
      var t = span.textContent.trim();
      if (t.indexOf('Collections li') !== -1) {
        var details = span.closest('details');
        if (details) details.style.display = 'none';
      }
    });
  }

  /* ── Step 3 : Find sidebar and run ─────────────────── */
  function init() {
    // Pulzena sidebar: second .accordion-list (first is mega menu)
    var lists = document.querySelectorAll('.accordion-list');
    var sidebar = null;

    for (var i = 0; i < lists.length; i++) {
      // Sidebar accordion-list has .checkbox-control or .price-range inside
      // Must also be visible (skip facets-drawer which is display:none on desktop)
      if ((lists[i].querySelector('.checkbox-control') || lists[i].querySelector('.price-range'))
          && lists[i].offsetWidth > 0) {
        sidebar = lists[i].parentElement;
        break;
      }
    }

    if (sidebar) {
      injectCollectionsNav(sidebar);
    }

    enhanceFilters();
    tweakHeaderNav();
    fetchCollectionCounts();
  }

  /* ── Step 4 : Header nav tweaks ─────────────────────
     - Rename "Collections" → "Par Catégorie"
     - Mega menus (Par Catégorie + Technologie) non-clickable, hover only
     - Hide "Best-sellers" link */
  function tweakHeaderNav() {
    var items = document.querySelectorAll('.header__primary-nav-item');
    items.forEach(function (li) {
      var summary = li.querySelector(':scope > mega-menu-disclosure > details > summary');
      if (summary) {
        var t = summary.textContent.trim();
        if (t === 'Collections') summary.textContent = 'Par Catégorie';
        // All mega menus: hover-only, not clickable, match regular link style
        summary.removeAttribute('data-follow-link');
        summary.style.cursor = 'default';
        summary.style.fontWeight = '400';
        summary.style.opacity = '0.55';
        summary.style.fontSize = '13px';
      }

      var a = li.querySelector(':scope > a');
      if (a && a.textContent.trim() === 'Best-sellers') {
        li.style.display = 'none';
      }
    });
  }

  /* ── Run on DOM ready ──────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── MutationObserver : ré-appliquer après AJAX ────── */
  var observerTarget = document.querySelector('.collection') || document.body;
  var observer = new MutationObserver(function () {
    init();
  });
  observer.observe(observerTarget, { childList: true, subtree: true });

})();
